import { ArrowRight, Bell, Zap, MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { FaTelegramPlane } from "react-icons/fa";

const FEATURES = [
  { icon: Bell,          text: "Dars jadvali va o'zgarishlar"   },
  { icon: Zap,           text: "Imtihon natijalari"             },
  { icon: MessageCircle, text: "Maxsus takliflar va chegirmalar" },
];

export default function TelegramBanner() {
  return (
    <section style={{ padding: "64px 20px", background: "#fff" }}>
      <div style={{ maxWidth: 560, margin: "0 auto" }}>
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.45, ease: [0.4, 0, 0.2, 1] }}
          style={{ background: "#fff", border: "1.5px solid #ede9fe", borderRadius: 16, overflow: "hidden" }}
        >
          {/* Tepa */}
          <div style={{ padding: "20px 24px", borderBottom: "1.5px solid #ede9fe", display: "flex", alignItems: "center", gap: 14 }}>
            <div style={{ width: 42, height: 42, borderRadius: 12, flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", background: "#f5f3ff", border: "1.5px solid #ede9fe" }}>
              <FaTelegramPlane size={18} color="#7c3aed" />
            </div>

            <div style={{ flex: 1 }}>
              <p style={{ fontSize: 10, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", color: "#a78bfa", margin: 0, marginBottom: 2 }}>
                Rasmiy kanal
              </p>
              <h3 style={{ fontSize: 14, fontWeight: 700, color: "#1e1040", margin: 0, lineHeight: 1.3 }}>
                DevCore official channel
              </h3>
            </div>

            <a
              href="https://t.me/DevCore_channell"
              target="_blank"
              rel="noreferrer"
              style={{ display: "flex", alignItems: "center", gap: 6, background: "#7c3aed", color: "#fff", borderRadius: 10, padding: "9px 18px", fontSize: 12, fontWeight: 700, textDecoration: "none", flexShrink: 0 }}
            >
              Obuna
              <ArrowRight size={12} />
            </a>
          </div>

          {/* Past */}
          <div style={{ padding: "14px 24px", display: "flex", flexDirection: "column", gap: 10 }}>
            {FEATURES.map((f, i) => (
              <div key={i} style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <f.icon size={13} color="#a78bfa" style={{ flexShrink: 0 }} />
                <span style={{ fontSize: 13, color: "#64748b" }}>{f.text}</span>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}